import React, { useContext } from 'react';
import styled from 'styled-components';
import TagManager from 'react-gtm-module';

import { Select } from '@freenow/wave';
import { config } from '@mytaxi/config-store';

import { LocaleContext } from '../../common/context/LocaleContext';
import { useFormatMessage } from '../../common/hooks/useFormatMessage';

const GreySelect = styled(Select)`
    & select {
        background-color: transparent;
    }
`;

export const LanguageSwitcher = () => {
    const { locale, setLocale } = useContext(LocaleContext);
    const formatMessage = useFormatMessage();

    const handleLocaleChange = (event) => {
        TagManager.dataLayer({
            dataLayer: {
                event: 'Locale changed',
                oldLocale: locale,
                newLocale: event.target.value,
            },
        });
        setLocale(event.target.value);
    };

    return (
        <GreySelect size="small" width="140px" value={locale} ml={{ _: 0, medium: 3 }} onChange={handleLocaleChange}>
            {config.getItem('availableLocales').map((locale) => {
                return (
                    <option key={locale} value={locale}>
                        {formatMessage(`languages.${locale}`)}
                    </option>
                );
            })}
        </GreySelect>
    );
};
